import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row d-flex justify-content-center mb-2" }

import { socket } from "@/main";
import { ItagView } from '@/store/modules/Account';
import { AlertModule } from "@/store/modules/Alert";
import { AuthModule } from "@/store/modules/Auth";
import { TicketModule } from "@/store/modules/Ticket";


export default /*#__PURE__*/_defineComponent({
  props: {
    tag: null
  },
  setup(__props: any) {

const props = __props as {
	tag: ItagView
}



const toggleTag = (id: string, active: boolean) => {
	if(active) {
		socket.emit('TICKET_DEL_TAG', {
			token: AuthModule.token,
			ticket: TicketModule.currentRoomID,
			tag: id,
		})

		AlertModule.SOCKET_PUSH_NOTIFICATION({
			text: `Se ha eliminado la etiqueta del ticket`,
			type: "warning",
		});
	} else {
		socket.emit('TICKET_ADD_TAG', {
			token: AuthModule.token,
			ticket: TicketModule.currentRoomID,
			tag: id,
		})

		AlertModule.SOCKET_PUSH_NOTIFICATION({
			text: `Se ha añadido la etiqueta del ticket`,
			type: "success",
		});
	}
}


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_tooltip, {
      content: props.tag.descripcion,
      placement: "left"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_button, {
          class: "col-11",
          style: _normalizeStyle(`border-color: ${props.tag.color};color: ${props.tag.selected?'white':props.tag.color}; background-color: ${props.tag.selected?props.tag.color:'white'};`),
          size: "small",
          disabled: _unref(TicketModule).isOldTicket,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleTag(props.tag._id, props.tag.selected)))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(props.tag.nombre), 1)
          ]),
          _: 1
        }, 8, ["style", "disabled"])
      ]),
      _: 1
    }, 8, ["content"])
  ]))
}
}

})